import { createSelector } from '@reduxjs/toolkit';

import { ModelCategory, ProjectLayoutModel } from '@paragon/contract-library';
import { getLayoutModels } from '@paragon/layout-models';

export const getProjectLayoutModels = createSelector(
  getLayoutModels,

  (layoutModels): ProjectLayoutModel[] =>
    layoutModels.filter((layoutModel) => layoutModel.category === ModelCategory.Project) as ProjectLayoutModel[],
);
